/*
 * Copyright (C) 2026 Das Land Schleswig-Holstein vertreten durch den
 * Ministerpräsidenten des Landes Schleswig-Holstein
 * Staatskanzlei
 * Abteilung Digitalisierung und zentrales IT-Management der Landesregierung
 *
 * Lizenziert unter der EUPL, Version 1.2 oder - sobald
 * diese von der Europäischen Kommission genehmigt wurden -
 * Folgeversionen der EUPL ("Lizenz");
 * Sie dürfen dieses Werk ausschließlich gemäß
 * dieser Lizenz nutzen.
 * Eine Kopie der Lizenz finden Sie hier:
 *
 * https://joinup.ec.europa.eu/collection/eupl/eupl-text-eupl-12
 *
 * Sofern nicht durch anwendbare Rechtsvorschriften
 * gefordert oder in schriftlicher Form vereinbart, wird
 * die unter der Lizenz verbreitete Software "so wie sie
 * ist", OHNE JEGLICHE GEWÄHRLEISTUNG ODER BEDINGUNGEN -
 * ausdrücklich oder stillschweigend - verbreitet.
 * Die sprachspezifischen Genehmigungen und Beschränkungen
 * unter der Lizenz sind dem Lizenztext zu entnehmen.
 */
import { Component, ElementRef, inject, signal, WritableSignal } from '@angular/core';

@Component({
  selector: 'ods-tab-panel',
  template: `@if (show()) {
    <ng-content />
  }`,
  host: {
    class:
      'empty:hidden border-grayborder flex-2/3 rounded-md border focus-visible:outline-focus focus-visible:outline-2 outline-offset-2 text-text',
    role: 'tabpanel',
    '[id]': 'id()',
    '[attr.aria-labelledby]': 'buttonId()',
    '[tabindex]': 'show() ? 0 : -1',
  },
})
export class TabPanelComponent {
  public ref: ElementRef<HTMLElement> = inject(ElementRef);
  public show: WritableSignal<boolean> = signal(false);
  public id: WritableSignal<string> = signal('');
  public buttonId: WritableSignal<string> = signal('');
}
